import VEHICLES_LCA_FACTORS from '@/../data/factors/lca/vehiclesFactors.json'

import _ from 'lodash'

const DECOMPOSITION = {
  co2: 0.0,
  ch4: 0.0,
  n2o: 0.0,
  other: 0.0,
  total: 0.0,
  uncertainty: 0.0
}

class Factor {
  constructor (
    decomposition = {},
    category = null,
    subcategory = null,
    subsubcategory = null,
    descriptionFR = '',
    descriptionEN = '',
    unit = null,
    group = null
  ) {
    this.decomposition = decomposition
    this.category = category
    this.subcategory = subcategory
    this.subsubcategory = subsubcategory
    this.descriptionFR = descriptionFR
    this.descriptionEN = descriptionEN
    this.unit = unit
    this.group = group
  }

  getYear (year = null) {
    let cyear = null
    if (this.decomposition.length === 1) {
      cyear = Object.keys(this.decomposition)[0]
    } else {
      if (year !== null) {
        if (Object.keys(this.decomposition).includes(String(year))) {
          cyear = String(year)
        } else {
          // if does not exist, find the closest year available
          let beforeYears = Object.keys(this.decomposition).filter(
            (val) => parseInt(val) <= parseInt(year)
          )
          if (beforeYears.length === 1) {
            cyear = beforeYears[0]
          } else if (beforeYears.length > 1) {
            let closest = beforeYears.reduce((a, b) => {
              return Math.abs(parseInt(b) - parseInt(year)) <
                Math.abs(parseInt(a) - parseInt(year))
                ? b
                : a
            })
            cyear = String(closest)
          } else {
            let closest = Object.keys(this.decomposition).reduce((a, b) => {
              return Math.abs(parseInt(b) - parseInt(year)) <
                Math.abs(parseInt(a) - parseInt(year))
                ? b
                : a
            })
            cyear = String(closest)
          }
        }
      } else {
        // find the closest to current year
        let cYear = new Date().getFullYear()
        let closest = Object.keys(this.decomposition).reduce((a, b) => {
          return Math.abs(parseInt(b) - parseInt(cYear)) <
            Math.abs(parseInt(a) - parseInt(cYear))
            ? b
            : a
        })
        cyear = String(closest)
      }
    }
    return cyear
  }
}

export class ImpactFactor extends Factor {
  getFactor (year = null) {
    let cyear = this.getYear(year)
    let factor = _.cloneDeep(this.decomposition[cyear])
    return factor
  }

  isEmpty () {
    return Object.keys(this.decomposition).length === 0
  }

  isEqualTo (obj) {
    let isEqual = false
    if (
      this.category === obj.category &&
      this.subcategory === obj.subcategory &&
      this.subsubcategory === obj.subsubcategory &&
      this.descriptionFR === obj.descriptionFR &&
      this.descriptionEN === obj.descriptionEN &&
      this.unit === obj.unit &&
      this.group === obj.group
    ) {
      isEqual =
        JSON.stringify(this.decomposition) === JSON.stringify(obj.decomposition)
    }
    return isEqual
  }

  static get keys () {
    let factor = ImpactFactor.createFromObj(
      VEHICLES_LCA_FACTORS['car']['gasoline']
    ).getFactor()
    return Object.keys(factor)
  }

  static createFromObj (factor) {
    if (factor) {
      return new ImpactFactor(
        factor.decomposition,
        factor.category,
        factor.subcategory,
        factor.subsubcategory,
        factor.descriptionFR,
        factor.descriptionEN,
        factor.unit,
        factor.group
      )
    } else {
      let cdate = new Date().getFullYear()
      return new ImpactFactor(
        {
          [cdate]: {}
        },
        null,
        null,
        null,
        '',
        '',
        null,
        null
      )
    }
  }
}

export class EmissionFactor extends Factor {
  getFactor (year = null) {
    let cyear = this.getYear(year)
    let factor = _.cloneDeep(this.decomposition[cyear])
    for (let key of Object.keys(factor)) {
      if (typeof factor[key] === 'object') {
        factor[key] = Object.assign({}, DECOMPOSITION, factor[key])
      }
    }
    factor.group = this.group
    return factor
  }

  getDecompositionKeys (year = null) {
    let cyear = this.getYear(year)
    return Object.keys(this.decomposition[cyear])
  }

  hasDecomposition (year = null) {
    let cyear = this.getYear(year)
    return Object.keys(this.decomposition[cyear]).length > 1
  }

  static isEmpty (factor) {
    return factor.total.total === 0.0 && factor.group === null
  }

  static createFromObj (factor = null) {
    if (factor) {
      return new EmissionFactor(
        factor.decomposition,
        factor.category,
        factor.subcategory,
        factor.subsubcategory,
        factor.descriptionFR,
        factor.descriptionEN,
        factor.unit,
        factor.group
      )
    } else {
      let cdate = new Date().getFullYear()
      return new EmissionFactor(
        {
          [cdate]: {
            total: DECOMPOSITION,
            combustion: DECOMPOSITION,
            upstream: DECOMPOSITION,
            manufacturing: DECOMPOSITION
          }
        },
        null,
        null,
        null,
        '',
        '',
        null,
        null
      )
    }
  }
}
